import React from "react";
import { Link } from "react-router-dom";
import { Header, Icon, Table } from "semantic-ui-react";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../../commons/functions/generalFunctions";
const MovilDescriptionTable = ({ item }) => {
  return (
    <Table collapsing style={{ width: "100%" }}>
      {item.orderHistory.map((product, key) => (
        <Table.Body key={key}>
          <Table.Row>
            <Table.HeaderCell textAlign="center">
              <Header as="h2">
                <Header.Content>{`No. ${key + 1}`}</Header.Content>
              </Header>
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Código</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">{product.code}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Nombre</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">{product.name}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Texto Personalizado</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">
              {product.customText ? product.customText : "No"}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Costo de Texto Personalizado</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">
              {item.currency === "USD"
                ? formatterUSD.format(parseFloat(product.customizationCost))
                : formatCurrency(parseFloat(product.customizationCost))}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Cantidad</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">{product.quantity}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Precio Unidad</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">
              {item.currency === "USD"
                ? formatterUSD.format(parseFloat(product.price))
                : formatCurrency(parseFloat(product.price))}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>
              <Header as="h4">
                <Header.Content>Total</Header.Content>
              </Header>
            </Table.Cell>
            <Table.Cell textAlign="center">
              {item.currency === "USD"
                ? formatterUSD.format(parseFloat(product.total))
                : formatCurrency(parseFloat(product.total))}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell textAlign="center">
              <Link to={`/product/${product.id}`}>
                <Icon name="eye" />
              </Link>
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      ))}
    </Table>
  );
};

export default MovilDescriptionTable;
